
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VMDutyCreate } from '../../../backend/backendapi';
import { WindowType } from '../../../../util';

declare var window: WindowType;

@Component({
  name: 'ConditionBasedMonitoring',
  components: {},
})
export default class ConditionBasedMonitoring extends Vue {
  @Prop({ required: true })
  readonly dutyCreate!: VMDutyCreate;

  get anyCbmEnabled(): boolean {
    return this.dutyCreate.duty.cbmAnonymousEnabled || (this.dutyCreate.duty.cbmAuthedId?.trim().length ?? 0) > 0;
  }

  get cbmAnonymousIdUrl(): string {
    if (!this.dutyCreate.duty.cbmAnonymousId) {
      return '';
    }
    return window.location.protocol + '//' + window.location.host + window.application.baseUrl + 'quick/cbm/anonymous/duty/' + this.dutyCreate.duty.cbmAnonymousId;
  }

  get canWorkFlow(): boolean {
    return window.application.permissions.kanban.workflow;
  }

  copyLink(): void {
    window.navigator.clipboard.writeText(this.cbmAnonymousIdUrl);
    this.$toasted.info(this.$t('txtCopiedToClipboard').toString());
  }
}
